import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const UserSessionsActions = {

  fetchUserSessions: async _ => {
    return axiosRequest.
      get('/users/sessions').
      then(({ data }) => data.sessions).
      catch(handleError)
  },

  revokeOtherUserSessions: async _ => {
    return axiosRequest.
      delete('/users/sessions/others').
      catch(handleError)
  },

  revokeUserSession: async (_, sessionId) => {
    return axiosRequest.
      delete(`/users/sessions/${sessionId}`).
      catch(handleError)
  },

}
